<script setup>
import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer'
const $customizer = useCustomizer()

import moment from 'moment'

import { Icon } from '@components'

import { computed, ref } from 'vue'

const props = defineProps({
    slot: {
        type: Object
    }
})

const setValue = (slot) => {
    if (!slot.available) return

    $appointments.setAppointment('booking_time_start', slot.start,false)
    $appointments.setAppointment('booking_time_end', slot.end,false)
}

const timePeriod = (slot_start) => {
    const hour = moment(slot_start, 'HH:mm').hour()

    if (hour >= 6 && hour < 12) {
        return 'Morning'
    } else if (hour >= 12 && hour < 18) {
        return 'Afternoon'
    } else {
        return 'Evening'
    }
}

const timeIcon = ref({
    Morning: 'sunSetting02',
    Afternoon: 'sun',
    Evening: 'moonStar',
})

// format time depending on customizer
const formatTime = (time, format) => {
    if ($settings.customizer.time.show_time) {
        return moment(time, format).format('HH:mm')
    } else {
        return moment(time, format).format('hh:mm A')
    }
}

const isActive = computed(() => {
    return $appointments.appointment.booking_time_start === props.slot.start
})

const isHover = ref(false)
</script>

<style lang="scss" scoped></style>

<template>
    <div @click="setValue(props.slot)" @mouseover="isHover = true" @mouseleave="isHover = false" class="time-item" :class="isActive ? 'time-active' : 'time-inactive', { 'time-deactive': !props.slot.available }" :style="`background-color: ${isActive ? `${$settings.customizer.design.brand_color}` : ''} !important;  border-radius: ${$customizer.isRounded ? '' : '0px'} !important; color: ${isHover ? `${$settings.customizer.design.brand_color}` : ''}`">
        <Icon v-if="$settings.customizer.time.show_time_icon" :name="timeIcon[timePeriod(props.slot.start) || 'Morning']" size="16px" />
        <div class="time-text">{{ formatTime(props.slot.start, 'HH:mm') }}</div>
    </div>
</template>